import React, { Suspense } from 'react';

import salesTypes from 'maps/sales-types';

import DownloadKPIs from 'components/data-containers/KPIs/Download/DownloadKPIs';
import PerformanceTrendSkeletonLoader from 'components/data-containers/PerformanceTrend/SkeletonLoader';
import PerformanceBreakdownLoader from 'components/data-containers/PerformanceBreakdown/SkeletonLoader';

const DownloadPerformanceTrend = React.lazy(() =>
  import(
    'components/data-containers/PerformanceTrend/PerformanceComponent/PerformanceComponent'
  )
);

const PerformanceBreakdown = React.lazy(() =>
  import('components/data-containers/PerformanceBreakdown/PerformanceBreakdown')
);

const Download: React.FC = () => {
  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <DownloadKPIs glossarySlug="kpis/download-kpis" />

      <Suspense
        fallback={
          <PerformanceTrendSkeletonLoader
            title="Download Performance"
            dropdownLabel="All DSPs"
            toggleOptions={[
              { value: 'aggregate', label: 'All DSPs', active: true },
              { value: 'all', label: 'By DSP', active: false },
            ]}
            showPeriodDropdown
          />
        }
      >
        <DownloadPerformanceTrend
          componentId="track-download-performance-trend"
          salesType={salesTypes.track_downloads}
          title="Download Performance"
        />
      </Suspense>

      <Suspense fallback={<PerformanceBreakdownLoader barCount={3} />}>
        <PerformanceBreakdown
          salesType={salesTypes.track_downloads}
          hasDSPSelector
        />
      </Suspense>
    </div>
  );
};

export default Download;
